
export class RolePermissionBO {
    roleId: string;
    roleName: string;
    hasAllPermission: boolean;
    menuPermissions: MenuPermissionBO[];
}

export class MenuPermissionBO {
    menuId: string;
    menuName: string;
    hasPermisison: boolean;
    functionPermissions: FunctionPermissionBO[];
    subMenuPermissions: MenuPermissionBO[];
}

export class FunctionPermissionBO {
    functionId: string;
    functionName: string;
    hasPermisison: boolean;
}

export class PermissionUpdationBasedOnRoleBO {
    roleId: string;
    isEnabled: boolean;
}

export class SideMenuRolePermissionBO {
    sideMenuId: string;
    loginRoleId: string;
    hasPermission: boolean;
}

export class MenuFunctionalityRolePermissionBO {
    menuFunctionalityId: string;
    loginRoleId: string;
    hasPermission: boolean;
    sideMenuId: string;
}
export class PermissionUpdationBO {
    loginRoleId: string;
    isEnabled: boolean;
}

export class SaveMenuAndFunctionalityBO {
    isMenu: boolean;
    sideMenuRolePermission: SideMenuRolePermissionBO;
    menuFunctionalityRolePermission: MenuFunctionalityRolePermissionBO;
}


export class RolePermissionMenu {
    roleMenu: roleMenu[];
    rolePermissiondata: rolePermissiondata[];
    isSelectAllEnabled: boolean;
}

export class roleMenu {
    roleHeading: string;
    isRoleEnabled: boolean;
}

export class RolePermissionMappingData {
    isEnabled: boolean;
    loginRoleId: string;
    menuItemsId: number | null;
    menuFunctionalityId: number | null;
    rolePermissionId: number;
}

export class rolePermissiondata {
    menuName: string;
    isSubMenu: boolean | null;
    isFunctionMenu: boolean | null;
    rolePermissionMappingData: RolePermissionMappingData[];
}